// extracted by mini-css-extract-plugin
module.exports = {"container":"expressPartMob__container___XECwY","errors":"expressPartMob__errors___1zXhG","over-footer":"expressPartMob__over-footer___1bBBc"};